import { paymentStatementApi } from './base';

// ROC-102: the four BASYS roles. Stored role `user` reads as Sales, `admin` as Admin.
export type BusinessRole = 'sales' | 'pricing' | 'manager' | 'admin';
export type ApproverRole = Exclude<BusinessRole, 'sales'>;

export interface RolePermissions {
	see_iso_profit: BusinessRole[];
	approve_rate_outside_template: ApproverRole;
	approve_margin_below_floor: ApproverRole;
}

export interface RolePermissionsResponse {
	success: boolean;
	permissions: RolePermissions;
	role: BusinessRole;
	can_see_iso_profit: boolean;
}

export const rolePermissionsApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		getRolePermissions: builder.query<RolePermissionsResponse, void>({
			query: () => ({ url: '/tenant/role-permissions', method: 'GET' }),
			providesTags: ['RolePermissions'],
		}),
		saveRolePermissions: builder.mutation<
			RolePermissionsResponse,
			RolePermissions
		>({
			query: (body) => ({
				url: '/tenant/role-permissions',
				method: 'PUT',
				body,
			}),
			// Profit fields in statement responses depend on these settings.
			invalidatesTags: [
				'RolePermissions',
				'StatementList',
				'Statement',
				'LineItems',
			],
		}),
	}),
});

export const { useGetRolePermissionsQuery, useSaveRolePermissionsMutation } =
	rolePermissionsApi;
